function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Commercial delivery ");

var SvgBox = function SvgBox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("g", {
    id: "_Group_2",
    "data-name": " Group 2"
  }, React.createElement("path", {
    d: "M496,254.18v202.1a23.091,23.091,0,0,1-23.08,23.09H335.89a23.084,23.084,0,0,1-23.08-23.09V254.18a23.076,23.076,0,0,1,23.08-23.08h31.17v.07a17.156,17.156,0,0,0,17.16,17.16h40.37a17.156,17.156,0,0,0,17.16-17.16v-.07h31.17A23.082,23.082,0,0,1,496,254.18ZM376.92,382.13V349.15H343.95v32.98Z",
    style: {
      fill: "#f8ec7d"
    }
  }), React.createElement("path", {
    d: "M367.06,231.1v-1.05a17.156,17.156,0,0,1,17.16-17.16h40.37a17.156,17.156,0,0,1,17.16,17.16v1.12a17.156,17.156,0,0,1-17.16,17.16H384.22a17.156,17.156,0,0,1-17.16-17.16Z",
    style: {
      fill: "#6fe3ff"
    }
  }), React.createElement("path", {
    d: "M391.31,140.98v71.91h-7.09a17.156,17.156,0,0,0-17.16,17.16v1.05H335.89a23.076,23.076,0,0,0-23.08,23.08v148.8L203.65,466V249.3L391.29,140.97Z",
    style: {
      fill: "#c16752"
    }
  }), React.createElement("polygon", {
    points: "203.65 249.3 107.99 194.07 295.62 85.73 295.63 85.73 391.29 140.97 203.65 249.3",
    style: {
      fill: "#af593c"
    }
  }), React.createElement("rect", {
    x: 343.95,
    y: 349.15,
    width: 32.97,
    height: 32.98,
    style: {
      fill: "#6fe3ff"
    }
  }), React.createElement("polygon", {
    points: "295.62 85.73 107.99 194.07 16.02 140.97 203.65 32.63 295.62 85.73",
    style: {
      fill: "#af593c"
    }
  }), React.createElement("polygon", {
    points: "203.65 249.3 203.65 466 16 357.66 16 140.98 16.02 140.97 107.99 194.07 203.65 249.3",
    style: {
      fill: "#e48e66"
    }
  }), React.createElement("path", {
    d: "M472.92,224H448.007a24.532,24.532,0,0,0-23.417-18H398V140.98a6.89,6.89,0,0,0-3.385-6.084L299.053,79.668l-3.279,6.07H296v-.016l3.308-6.054-92.064-53.1a7.085,7.085,0,0,0-7.047,0L12.642,134.851A7.021,7.021,0,0,0,9,140.98V357.66a7,7,0,0,0,3.5,6.062l187.65,108.34a6.987,6.987,0,0,0,3.5.938,7.343,7.343,0,0,0,3.6-.938L306,415.1V456.28A29.643,29.643,0,0,0,335.89,486H472.92A29.8,29.8,0,0,0,503,456.28V254.18A30.2,30.2,0,0,0,472.92,224ZM435,230.05v1.12c0,5.6-4.808,9.83-10.41,9.83H384.22A9.96,9.96,0,0,1,374,231.1v-1.05A10.129,10.129,0,0,1,384.22,220h40.37A10.3,10.3,0,0,1,435,230.05Zm-57.709-89.08L203.65,241.217,121.989,194.07,295.624,93.81ZM203.65,40.713,281.621,85.73,107.99,185.987,30.019,140.97ZM23,153.083,197,253.341V453.876L23,353.619ZM211,453.876V253.342L384,153.083V206h.22A24.532,24.532,0,0,0,360.8,224H335.89A30.038,30.038,0,0,0,306,254.18V398.939Zm278,2.4A15.791,15.791,0,0,1,472.92,472H335.89A15.629,15.629,0,0,1,320,456.28V254.18A16.022,16.022,0,0,1,335.89,238h25.187a23.943,23.943,0,0,0,23.143,17h40.37a23.941,23.941,0,0,0,23.142-17H472.92A16.184,16.184,0,0,1,489,254.18Z",
    style: {
      fill: "#63316d"
    }
  }), React.createElement("path", {
    d: "M343.95,325h7.33a7,7,0,0,0,0-14H351V292h19.3a6.739,6.739,0,0,0,6.657,4.725A7.021,7.021,0,0,0,384,289.74v-4.71a7.094,7.094,0,0,0-7.08-7.03H343.95a6.983,6.983,0,0,0-6.95,7.03v32.98A6.949,6.949,0,0,0,343.95,325Z",
    style: {
      fill: "#63316d"
    }
  }), React.createElement("path", {
    d: "M384,349a7,7,0,0,0-7-7H344a7,7,0,0,0-7,7v33a7,7,0,0,0,7,7h33a7,7,0,0,0,7-7Zm-33,7h19v19H351Z",
    style: {
      fill: "#63316d"
    }
  }), React.createElement("path", {
    d: "M351.28,439H351V420h18.925a7.04,7.04,0,0,0,14.075.01v-6.74a7.3,7.3,0,0,0-7.08-7.27H343.95a7.193,7.193,0,0,0-6.95,7.27v32.97a6.756,6.756,0,0,0,6.95,6.76h7.33a7,7,0,0,0,0-14Z",
    style: {
      fill: "#63316d"
    }
  }), React.createElement("path", {
    d: "M393.04,286.59l-20.5,20.5-6.241-6.235a7,7,0,1,0-9.9,9.9l11.191,11.18a7,7,0,0,0,9.9,0l25.45-25.45a7,7,0,1,0-9.9-9.9Z",
    style: {
      fill: "#63316d"
    }
  }), React.createElement("path", {
    d: "M393.04,415.84l-20.5,20.5-6.241-6.235a7,7,0,1,0-9.9,9.9l11.191,11.18a7,7,0,0,0,9.9,0l25.45-25.45a7,7,0,1,0-9.9-9.9Z",
    style: {
      fill: "#63316d"
    }
  }), React.createElement("path", {
    d: "M464.86,295H420.89a7,7,0,0,0,0,14h43.97a7,7,0,0,0,0-14Z",
    style: {
      fill: "#63316d"
    }
  }), React.createElement("path", {
    d: "M464.86,359H420.89a7,7,0,0,0,0,14h43.97a7,7,0,0,0,0-14Z",
    style: {
      fill: "#63316d"
    }
  }), React.createElement("path", {
    d: "M464.86,423H420.89a7,7,0,0,0,0,14h43.97a7,7,0,0,0,0-14Z",
    style: {
      fill: "#63316d"
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/box.df01745c.svg";
export { ForwardRef as ReactComponent };